// store/balance/createBalanceSlice.ts

import { StateCreator } from 'zustand';
import { transactionsInitialState, TransactionsState } from './transactionsInitialState';
import { GrandLivreInfos, Transaction } from '../../types';
import { FilterType } from '../../components/Transactions/FiltersDivers/TagRendering/TagMapping';
import { createFunctionalSetter } from '../storeCommons';

/**
 * @french
 * Interface des actions liées aux transactions.
 */
export interface TransactionsActions {
  setClickedEcritureId: (id: string | null) => void;
  setIsEcritureHistoryModalOpen: (open: boolean) => void;
  setSelectedValues: (updater: FilterType[] | ((prev: FilterType[]) => FilterType[])) => void;
  setSavedFilters: (
    updater: Map<FilterType, any> | ((prev: Map<FilterType, any>) => Map<FilterType, any>),
  ) => void;
  setIsExportModalVisible: (visible: boolean) => void;
  setSelectedTransactions: (transactions: Transaction[]) => void;
  setIsAddTagToTransactionModalVisible: (visible: boolean) => void;
  setFiltredTransactions: (transactions: Transaction[]) => void;
  setIsListTransactionsParCompteEmpty: (empty: boolean) => void;
  setIsDeleteModalVisible: (visible: boolean) => void;
  setIsDeleteLettrageModalVisible: (visible: boolean) => void;
  setIsLettrageModalVisible: (visible: boolean) => void;
  setRelatedEcrituresCount: (count: number) => void;
  setUniquePieceIdsCount: (count: number) => void;
  setGrandLivreDataSource: (data: GrandLivreInfos[]) => void;
  setIsMarkAsViewModalVisible: (visible: boolean) => void;
  setIsReverseModalVisible: (visible: boolean) => void;
  SetIsSecondaryTransactionsLoading: (isSecondaryTransactionsLoading: boolean) => void;
  SetIsLettrerModalVisible: (isLettrerModalVisible: boolean) => void;
  setSecondarySelectedTransactions: (transactions: Transaction[]) => void;
  setIsTransfertDeCompteACompteVisible: (visible: boolean) => void;
  setIsReaffecterModalVisible: (visible: boolean) => void;
  setIsTransactionsLoading: (loading: boolean) => void;
  setIsActionLoading: (loading: boolean) => void;
  setAccountId: (id: number) => void;
  setSelectedTransactionInfo: (info: { ecritureIndex: number; transactionIndex: number }) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour les actions des transactions.
 */
export const createTransactionsSlice: StateCreator<
  TransactionsState & TransactionsActions,
  [],
  [],
  TransactionsActions
> = (set, get) => ({
  setClickedEcritureId: (id) => set({ clickedEcritureId: id }),
  setIsEcritureHistoryModalOpen: (open) => set({ isEcritureHistoryModalOpen: open }),
  setSelectedValues: createFunctionalSetter(get, set, 'selectedValues'),
  setSavedFilters: createFunctionalSetter(get, set, 'savedFilters'),
  setIsExportModalVisible: (visible) => set({ isExportModalVisible: visible }),
  setSelectedTransactions: (transactions) => set({ selectedTransactions: transactions }),
  setIsAddTagToTransactionModalVisible: (visible) =>
    set({ isAddTagToTransactionModalVisible: visible }),
  setFiltredTransactions: (transactions) => set({ filtredTransactions: transactions }),
  setIsListTransactionsParCompteEmpty: (empty) => set({ isListTransactionsParCompteEmpty: empty }),
  setIsDeleteModalVisible: (visible) => set({ isDeleteModalVisible: visible }),
  setIsDeleteLettrageModalVisible: (visible) => set({ isDeleteLettrageModalVisible: visible }),
  setIsLettrageModalVisible: (visible) => set({ isLettrageModalVisible: visible }),
  setRelatedEcrituresCount: (count) => set({ relatedEcrituresCount: count }),
  setUniquePieceIdsCount: (count) => set({ uniquePieceIdsCount: count }),
  setGrandLivreDataSource: (data) => set({ grandLivreDataSource: data }),
  setIsMarkAsViewModalVisible: (visible) => set({ isMarkAsViewModalVisible: visible }),
  setIsReverseModalVisible: (visible) => set({ isReverseModalVisible: visible }),
  setIsTransfertDeCompteACompteVisible: (visible) =>
    set({ isTransfertDeCompteACompteVisible: visible }),
  setIsReaffecterModalVisible: (visible) => set({ isReaffecterModalVisible: visible }),
  SetIsLettrerModalVisible: (isLettrerModalVisible) => set({ isLettrerModalVisible }),
  SetIsSecondaryTransactionsLoading: (isSecondaryTransactionsLoading) =>
    set({ isSecondaryTransactionsLoading }),
  setSecondarySelectedTransactions: (secondarySelectedTransactions) =>
    set({ secondarySelectedTransactions }),
  setIsTransactionsLoading: (loading) => set({ isTransactionsLoading: loading }),
  setIsActionLoading: (loading) => set({ isActionLoading: loading }),
  setAccountId: (accountId) => set({ accountId }),
  setSelectedTransactionInfo: (selectedTansactionInfo) =>
    set({ selectedTransactionInfo: selectedTansactionInfo }),
  reset: () => set(transactionsInitialState),
});
